function getAgreementSentence(section, agreement) {
  let acceptedStatus = false;

  if (agreement) {
    const sentences = agreement.sentences || [];
    const acceptedSentences = sentences.filter(
      (item) =>
        item.section.replace(/\s/g, '') === section ||
        item.section.replace(/\s/g, '') === `${section}title`
    );
    acceptedStatus = acceptedSentences.length > 0;
  }
  return acceptedStatus;
}

export default getAgreementSentence;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/helpers/getAgreementSentence.js